// src/pages/legal/PrivacyPolicy.js
import React from 'react';
import { useParams } from 'react-router-dom';
import '../LegalPages.css'; // A shared CSS file for styling

const PrivacyPolicy = () => {
  const { lang } = useParams();
  // You would paste your HTML content here
  const privacyHtml = `
  <h1>Privacy Policy — SeegSoog.com</h1>
  <p><strong>Effective Date:</strong> December 11, 2025</p>

  <h2>1. Information We Collect</h2>
  <ul>
    <li>Contact details: Name, email, phone number, country code</li>
    <li>Profile details: Username, age verification information (age range or confirmation of being over 18)</li>
    <li>Property data: Listings created or saved</li>
    <li>Property financial data (provided by Providers): Estimated ROI, expenses, etc.</li>
    <li>Usage data: Saved reports, saved homes</li>
    <li>Communication preferences and promotional opt-in status</li>
    <li>Investment profile data (if provided)</li>
  </ul>

  <h2>2. How We Use Your Information</h2>
  <ul>
    <li>Enable personalized Provider and Investor tools</li>
    <li>Improve listings, statistics, and platform features</li>
    <li>Respond to inquiries and support requests</li>
    <li>Send updates and promotional messages (if opted-in)</li>
    <li>Monitor platform activity for security and optimization</li>
  </ul>

  <h2>3. Third-Party Sharing</h2>
  <p>We do not sell your personal data.</p>
  <p>SeegSoog.com is operated by Log-Inn the Smart Home Ltd., Company Registration Number 514147305, Israel. This Privacy Policy applies to the operations of Log-Inn the Smart Home Ltd. on SeegSoog.com.</p>
  <p>We may share limited information with service providers for:</p>
  <ul>
    <li>Secure payment processing</li>
    <li>Email delivery (e.g. password reset, report sharing)</li>
    <li>Analytics and technical performance</li>
  </ul>

  <h2>4. Google User Data & OAuth</h2>
  <p>If you choose to sign in with your Google account, we access basic profile information as permitted by you during the consent process. This includes your name, email address, and age range.</p>
  <ul>
    <li><strong>How We Use It:</strong> This data is used exclusively to create and manage your account, personalize your profile, and verify that you meet our minimum age requirement.</li>
    <li><strong>Limitation of Use:</strong> Our use and transfer of information received from Google APIs will adhere to the <a href="https://developers.google.com/terms/api-services-user-data-policy#limited-use_requirements" target="_blank" rel="noopener noreferrer">Google API Services User Data Policy</a>, including the Limited Use requirements. We do not use this data for any other purpose.</li>
    <li><strong>Sharing:</strong> We do not share your Google user data with any third parties, except as necessary for security and to provide the core sign-in functionality. The one exception is when you choose to make an inquiry on a property listing. In this case, and only with your explicit confirmation, we will share your <strong>name and email address obtained from Google</strong> with the seller of that property to facilitate communication. For more details on what is shared, see the "Information Sharing Between Users" section below.</li>
  </ul>

  <h2>5. Information Sharing Between Users</h2>
  <p>To facilitate transactions and communication on our platform, we share certain information between Investors and Providers under specific conditions:</p>
  <ul>
    <li><strong>When you make an inquiry on a property:</strong> With your explicit confirmation, we will share your contact information (name, email, and phone number) and your investment profile with the Provider of that property. This allows the Provider to contact you and understand your investment needs.</li>
  </ul>

  <h2>6. Cookies, Analytics, and Tracking Technologies</h2>
  <p>We use cookies and similar tracking technologies to operate and personalize our website. This includes essential cookies for site functionality (like remembering your login or language preference) and optional analytics cookies to understand how our site is used.</p>
  <p>Specifically, we use Google Analytics to collect anonymous data about site traffic and user behavior. This helps us improve our services. You have full control over whether to allow these analytics cookies.</p>
  <p>You can manage your cookie preferences at any time through our cookie settings manager. For a detailed explanation of the cookies we use and how to control them, please see our <a href="/${lang}/cookie-policy">Cookie Policy</a>.</p>

  <h2>7. Data Security</h2>
  <p>Your data is encrypted and protected. Sensitive operations are monitored, and passwords are securely stored.</p>

  <h2>8. User Controls</h2>
  <ul>
    <li>Update your profile via the Edit Preferences page</li>
    <li>Opt in or out of promotional emails</li>
    <li>Request account deletion by contacting support</li>
  </ul>

  <h2>9. Children's Privacy</h2>
  <p>Our services are not intended for users under age 18. We do not knowingly collect data from minors.</p>

  <h2>10. Policy Updates</h2>
  <p>This Privacy Policy may be updated periodically. We will notify you through the site or by email.</p>

  <h2>11. Contact</h2>
  <p>For questions or requests, please use our <a href="/${lang}/contact-us">Contact Us</a> page.</p>
  `;

  return (
    <div className="legal-page-container">
      <div className="legal-content" dangerouslySetInnerHTML={{ __html: privacyHtml }} />
    </div>
  );
};

export default PrivacyPolicy;
